<template>
    <div>
        <table-template :queryParams="queryParams" actionUrl="/dbtCard/findDistributors.action"
                        ref="distributor-manager">
            <template slot="search">
                <el-select @change="$refs['distributor-manager'].search()" clearable placeholder="请选择"
                           v-model="queryParams.role">
                    <el-option :value="2" label="经纪人"></el-option>
                    <el-option :value="3" label="合伙人"></el-option>
                </el-select>
                <el-date-picker
                        @change="onCreateTimeChanged"
                        clearable
                        end-placeholder="加入时间截止"
                        range-separator="至"
                        start-placeholder="加入时间开始"
                        style="margin-left: 10px;"
                        type="datetimerange"
                        v-model="createTimeSearch">
                </el-date-picker>

                <el-input placeholder="昵称/手机号/邀请人昵称" style="margin-left: 10px;width: 200px;"
                          v-model="queryParams.keyword"></el-input>
                <el-button @click="$refs['distributor-manager'].search()"    style="margin-left: 10px;" type="primary">搜索
                </el-button>

            </template>
            <template slot="item">
                <el-table-column
                        label="用户信息"
                        prop="nickname" width="220px">
                    <template scope="scope">
                        <el-row> {{scope.row.nickname}}</el-row>
                        <el-row> {{scope.row.phone}}</el-row>
                    </template>
                </el-table-column>

                <el-table-column
                        label="角色"
                        prop="name"
                        width="70%">
                    <template scope="scope">
                        {{scope.row.role | roleFilter}}
                    </template>
                </el-table-column>

                <el-table-column
                        label="云服务"
                        width="80px">
                    <template scope="scope">
                        <a @click="showChangeRecord(scope.row)" >{{scope.row.cardCanUsedCount}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                        label="直接推广"
                        width="160px">
                    <template scope="scope">
                        <el-row style=" white-space: nowrap;font-size: 10px">直招会员/成功数：<a @click="showMember(scope.row)">{{scope.row.inviterCount}}/{{scope.row.inviterPayCount}}</a>
                        </el-row>
                        <el-row style=" white-space: nowrap;font-size: 10px">招募经纪人：<a @click="showAgent(scope.row)">{{scope.row.inviterAgentCount}}</a>
                        </el-row>
                        <el-row style=" white-space: nowrap;font-size: 10px">招商入驻：{{scope.row.inviteBusinessCount}}
                        </el-row>
                    </template>
                </el-table-column>

                <el-table-column
                        label="推广收益"
                        width="140px">
                    <template scope="scope">
                        <el-row style=" white-space: nowrap;font-size: 10px">累计收益：<a @click="showProfit(scope.row)">{{scope.row.totalMoney?scope.row.totalMoney:0}} </a>
                        </el-row>
                        <el-row style=" white-space: nowrap;font-size: 10px">已提现：{{scope.row.withMoney}}
                        </el-row>
                        <el-row style=" white-space: nowrap;font-size: 10px">待提现：{{scope.row.canWithMoney}}
                        </el-row>
                    </template>
                </el-table-column>

                <el-table-column
                        label="加入时间"
                        prop="name"
                        width="230px">
                    <template scope="scope">
                        成为会员:{{scope.row.createTime | dateTimeFormat}}<br>
                        <span v-if = "scope.row.role == 2">成为经纪人:{{scope.row.joinUpgradeAgentTime | dateTimeFormat}}<br></span>
                        <span v-if = "scope.row.role == 3">
                            成为经纪人:{{scope.row.joinUpgradeAgentTime | dateTimeFormat}}<br>
                            成为合伙人:{{scope.row.joinUpgradeDealerTime | dateTimeFormat}}<br>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="关系"
                        prop="name"
                        >
                    <template scope="scope">
                        <span v-if="scope.row.inviterId">邀请人：{{scope.row.inviterName?scope.row.inviterName:'暂无昵称'}} - {{scope.row.inviterPhone}} </span>
                        <span v-else>邀请人：区域服务商</span>
                        <br>
                        <span v-if="scope.row.dealerId">合伙人：{{scope.row.dealerName?scope.row.dealerName:'暂无昵称'}} - {{scope.row.dealerPhone}} </span>
                        <span v-else>合伙人：区域服务商</span>
                    </template>
                </el-table-column>

                <el-table-column
                        label="操作"
                        width="120px" >
                    <template scope="scope">

                        <el-dropdown trigger="click">
                            <el-button class="el-dropdown-link" size="mini" type="primary">
                                更多操作<i class="el-icon-caret-bottom el-icon--right" style="color:#FFF"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :confirm-input-data="{id:scope.row.id}"
                                           :confirm-input-text="'确定充值给'+scope.row.nickname"
                                           @onInputConfirm="$refs['distributor-manager'].search()"
                                           confirm-input-type="number"
                                           requestUrl="dbtCard/distributionCard.action"
                                           type="text"
                                           v-confirm-input
                                           value-alias="cardCount">手动充值
                                </el-dropdown-item>
                                <el-dropdown-item  @click.native.prevent="showSettingMemberQr(scope.row)" v-permissions="'addMemberQr'">添加公众号</el-dropdown-item>

                                <el-dropdown-item  @click.native.prevent="selectChildren(scope.row)"  >查看推广数据</el-dropdown-item>

                                <!--<el-dropdown-item v-permissions="'sendCardPermisions'" :confirm-data="{id:scope.row.id,isSendCard:1}"
                                                  :confirm-title="'确认要开启会员赠卡吗？'"
                                                  @onConfirm="$refs['distributor-manager'].search()"
                                                  confirm-text="开启后，该合伙人旗下付费开通会员的用户都能免费赠送一次会员卡给亲友(会员卡从该合伙人账户支出)"
                                                  requestUrl="dbtCard/changeMemberSendCard.action"
                                                  style="color:#67C23A"
                                                  type="text"
                                                  v-confirm
                                                  v-if="scope.row.isSendCard==2 && scope.row.role == 3">开启会员赠卡
                                </el-dropdown-item>

                                <el-dropdown-item v-permissions="'sendCardPermisions'"  :confirm-data="{id:scope.row.id,isSendCard:2}"
                                                  :confirm-title="'确认要关闭会员赠卡吗？'"
                                                  @onConfirm="$refs['distributor-manager'].search()"
                                                  confirm-text="关闭后，该合伙人旗下付费开通会员的用户无法免费赠送一次会员卡给亲友"
                                                  requestUrl="dbtCard/changeMemberSendCard.action"
                                                  style="color:#F56C6C"
                                                  type="text"
                                                  v-confirm
                                                  v-if="scope.row.isSendCard==1 && scope.row.role == 3">关闭会员赠卡
                                </el-dropdown-item>-->

<!--                                <el-dropdown-item :confirm-data="{id:scope.row.id,enabled:2}"
                                                  :confirm-title="'确认要禁用（'+scope.row.phone+'）这个用户吗？'"
                                                  @onConfirm="$refs['distributor-manager'].search()"
                                                  confirm-text="禁用后，该用户不能参与推广操作，会员特权还是可继续享用。"
                                                  requestUrl="dbtCard/changeMemberDisabled.action"
                                                  style="color:#F56C6C"
                                                  type="text"
                                                  v-confirm
                                                  v-if="scope.row.enabled==1">禁用
                                </el-dropdown-item>

                                <el-dropdown-item :confirm-data="{id:scope.row.id,enabled:1}"
                                                  :confirm-title="'确认要解禁（'+scope.row.phone+'）这个用户吗？'"
                                                  @onConfirm="$refs['distributor-manager'].search()"
                                                  confirm-text="解禁后，该用户即可正常参与推广操作。"
                                                  requestUrl="dbtCard/changeMemberDisabled.action"
                                                  style="color:#67C23A"
                                                  type="text"
                                                  v-confirm
                                                  v-if="scope.row.enabled==2">解禁
                                </el-dropdown-item>-->

                                <el-dropdown-item :confirm-data="{id:scope.row.id}" :confirm-title="'确认要降级（'+scope.row.phone+'）这个用户吗？'"
                                                  @onConfirm="downgradeSuccess(scope.row.phone)"
                                                  confirm-text="降级后，该用户即为（经纪人）角色，相应的福利也会降低哦。"
                                                  requestUrl="dbtCard/distributorDowngrade.action"
                                                  type="text"
                                                  v-confirm
                                                  v-if="scope.row.role==3">降级
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </template>

                </el-table-column>

            </template>

        </table-template>
        <el-dialog :title="queryCardChangeRecordParams.phone+'的云服务明细'" :visible.sync="serviceCloudVisible">
            <table-template :queryParams="queryCardChangeRecordParams"
                            actionUrl="/dbtCard/findMyRightsCardChangeRecordByAdmin.action"
                            ref="card-change-record">
                <template slot="item">
                    <el-table-column
                            label="奖型"
                            prop="module">
                    </el-table-column>
                    <el-table-column
                            label="云服务支出/收入（次）">
                        <template scope="scope">
                            {{scope.row.icon==1?'-':'+'}} {{scope.row.cardNo}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="关联用户账号"
                            prop="extra">
                    </el-table-column>

                    <el-table-column
                            label="创建时间"
                            prop="createTime">
                    </el-table-column>

                </template>
            </table-template>
        </el-dialog>

        <el-dialog :title="queryMemberParams.phone+'的会员明细'" :visible.sync="memberVisible">
            <table-template :queryParams="queryMemberParams" actionUrl="/dbtCard/findMyMemberManagerByAdmin.action"
                            ref="member-table">
                <template slot="item">
                    <el-table-column
                            label="姓名"
                            prop="nickname">
                    </el-table-column>
                    <el-table-column
                            label="手机号"
                            prop="phone">
                    </el-table-column>
                    <el-table-column
                            label="角色">
                        <template scope="scope">
                            {{scope.row.role | roleFilter}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="会员开通时间">
                        <template scope="scope">
                            {{scope.row.createTime | dateTimeFormat}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="会员到期时间">
                        <template scope="scope">
                            {{scope.row.endTime | dateTimeFormat}}
                        </template>
                    </el-table-column>

                </template>
            </table-template>
        </el-dialog>

        <el-dialog :title="queryAgentParams.phone+'的招募经纪人明细'" :visible.sync="agentVisible">
            <table-template :queryParams="queryAgentParams" actionUrl="/dbtCard/findMyAgentManagerByAdmin.action"
                            ref="agent-table">
                <template slot="item">
                    <el-table-column
                            label="姓名"
                            prop="nickname">
                    </el-table-column>
                    <el-table-column
                            label="手机号"
                            prop="phone">
                    </el-table-column>
                    <el-table-column
                            label="角色">
                        <template scope="scope">
                            {{scope.row.role | roleFilter}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="云服务剩余次数"
                            prop="cardCanUsedCount">
                    </el-table-column>
                    <el-table-column
                            label="推广会员/成功">
                        <template scope="scope">
                            {{scope.row.memberTotalCount}} / {{scope.row.memberCount}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="招募经纪人"
                            prop="agentCount">
                    </el-table-column>
                    <el-table-column
                            label="招商入驻"
                            prop="inviteBusinessCount">
                    </el-table-column>
                    <el-table-column
                            label="累计收益/已提现/待提现">
                        <template scope="scope">
                            {{scope.row.cumulativeIncome}} / {{scope.row.withMoney}} / {{scope.row.canWithMoney}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="升级经济人时间">
                        <template scope="scope">
                            {{scope.row.upgradeAgentTime | dateTimeFormat}}
                        </template>
                    </el-table-column>

                </template>
            </table-template>
        </el-dialog>

        <el-dialog :title="queryProfitParams.phone+'的收益明细'" :visible.sync="profitVisible">
            <table-template :queryParams="queryProfitParams" actionUrl="/dbtCard/findMyProfitByAdmin.action"
                            ref="profit-table">
                <template slot="item">
                    <el-table-column
                            label="奖型"
                            prop="typeStr">
                    </el-table-column>
                    <el-table-column
                            label="获得收益">
                        <template scope="scope">
                            {{scope.row.money/100}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="关联用户账号"
                            prop="phone">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            prop="createTime">
                    </el-table-column>

                </template>
            </table-template>
        </el-dialog>

        <el-dialog :title="queryCounterParams.phone+'的推广数据'" :visible.sync="counterVisible">
            <table-template :queryParams="queryCounterParams" actionUrl="/dbtCard/selectChildren.action"
                            ref="member-counter">
                <template slot="item">
                    <el-table-column
                            label="累计推广总会员">
                        <template scope="scope">
                            {{scope.row.personaltotal}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="当前团队总会员">
                        <template scope="scope">
                            {{scope.row.teamTotal}}
                        </template>
                    </el-table-column>
                </template>
            </table-template>
        </el-dialog>

        <el-dialog :visible.sync="settingMemberQrDialog" title="添加公众号二维码" width="30%">
            <el-form :model="settingMemberQrForm" :rules="qrRules" @onEdited="onQrEdited"
                     class="demo-ruleForm" editAction="dbtCard/settingMemberQr.action" label-width="50px"
                     ref="ruleForm"
                     v-form>
                <el-form-item prop="qr">
                    <el-upload
                            :action="baseUrl+'upload/uploadPic'"
                            :data="{floder:'carExhibition'}"
                            :show-file-list="false"
                            class="avatar-uploader"
                            v-model="settingMemberQrForm.qr">
                        <img :src="settingMemberQrForm.qr.url"
                             class="avatar" v-if="settingMemberQrForm.qr&&settingMemberQrForm.qr.url">
                        <i class="el-icon-plus avatar-uploader-icon" v-else></i>
                    </el-upload>
                    <div style="color:#999;">点击图片 添加/修改，建议尺寸150*150</div>
                </el-form-item>

                <el-form-item>
                    <el-button @click="settingMemberQrDialog = false">取 消</el-button>
                    <el-button type="primary">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>
<script>
import TableTemplate from '@/components/TableTemplate'
import Config from '@/framework/configs/Config'

export default {
  name: 'distributor-manager',
  data () {
    return {
      queryCardChangeRecordParams: {},
      serviceCloudVisible: false,
      baseImageUrl: Config.imageUrl,
      queryMemberParams: {},
      memberVisible: false,
      settingMemberQrDialog: false,
      baseUrl: Config.baseUrl,
      settingMemberQrForm: {
        id: null,
        qr: null
      },
      qrRules: {
        qr: [{
          required: true,
          message: '请上传二维码'
        }]
      },
      queryAgentParams: {},
      agentVisible: false,

      queryCounterParams: {},
      counterVisible: false,

      queryProfitParams: {},
      profitVisible: false,

      createTimeSearch: null,
      queryParams: {},
      innerContent: [],
      confirmInputText: null
    }
  },
  components: { TableTemplate },
  filters: {
    typeFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 开通会员
          filterValue = '开通会员'
          break
        case 2:// 续费
          filterValue = '续费'
          break
        case 3:// 购买云服务包
          filterValue = '购买云服务包'
          break
        case 4:// 云服务营收
          filterValue = '云服务营收'
          break
        case 5:// 维保查询
          filterValue = '维保查询'
          break
        case 6:// 碰撞查询
          filterValue = '碰撞查询'
          break
        case 7:// 维保查询
          filterValue = '商品活动'
          break
        case 8:// 商家商品
          filterValue = '商家商品'
          break
        case 9:// 省心智联
          filterValue = '省心智联'
          break
        case 10:// 云豆线上充值
          filterValue = '云豆线上充值'
          break
        case 11:// 省心加油
          filterValue = '省心加油'
          break
        case 12:// 注册新会员
          filterValue = '注册新会员'
          break
      }
      return filterValue
    },
    roleFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 普通会员
          filterValue = '普通会员'
          break
        case 2:// 经纪人
          filterValue = '经纪人'
          break
        case 3:// 合伙人
          filterValue = '合伙人'
          break
      }
      return filterValue
    },
    realNameAuthStatusFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 未认证
          filterValue = '未认证'
          break
        case 2:// 待审核
          filterValue = '待审核'
          break
        case 3:// 已认证
          filterValue = '已认证'
          break
      }
      return filterValue
    },
    companyAuthStatusFilter (value) {
      let filterValue = '暂无'
      switch (value) {
        case 1:// 未认证
          filterValue = '未认证'
          break
        case 2:// 待审核
          filterValue = '待审核'
          break
        case 3:// 已认证
          filterValue = '已认证'
          break
      }
      return filterValue
    }
  },
  created () {
    const h = this.$createElement
    const input = h('input', {
      attrs: {
        class: 'el-input__inner',
        type: 'number',
        min: 1,
        placeholder: '请输入充值数量'
      }
    })

    const div = h('div', {
      domProps: {
        innerHTML: '<p style=\'margin-top:10px;font-weight: bold;\'>温馨提示：充值一经提交，<span style=\'color:red;\'>无法撤回</span>。</p>'
      }
    })

    this.innerContent = [input, div]
  },
  methods: {
    onQrEdited: function () {
      this.$message({
        message: '二维码提交成功！',
        type: 'success'
      })
      this.settingMemberQrDialog = false
      this.$refs['distributor-manager'].loadList()
    },
    showSettingMemberQr: function (data) {
      this.settingMemberQrDialog = true
      this.settingMemberQrForm.id = data.id
      if (data.qrcode) {
        this.settingMemberQrForm.qr = { url: this.baseImageUrl + data.qrcode }
      } else {
        this.settingMemberQrForm.qr = null
      }
    },
    downgradeSuccess (phone) {
      this.$message({
        message: phone + ' 降级成功',
        type: 'success'
      })
      this.$refs['distributor-manager'].search()
    },
    showProfit (data) {
      this.queryProfitParams.memberId = data.id
      this.queryProfitParams.phone = data.phone
      this.profitVisible = false
      this.profitVisible = true
      this.$refs['profit-table'].search()
    },
    showAgent (data) {
      this.queryAgentParams.memberId = data.id
      this.queryAgentParams.phone = data.phone
      this.agentVisible = true
      this.$refs['agent-table'].search()
    },
    showMember (data) {
      this.queryMemberParams.memberId = data.id
      this.queryMemberParams.phone = data.phone
      this.memberVisible = true
      this.$refs['member-table'].search()
    },
    selectChildren (data) {
      this.queryCounterParams.memberId = data.id
      this.queryCounterParams.phone = data.phone
      this.counterVisible = true
      this.$refs['member-counter'].search()
    },
    showChangeRecord (data) {
      this.queryCardChangeRecordParams.memberId = data.id
      this.queryCardChangeRecordParams.phone = data.phone
      this.serviceCloudVisible = true
      this.$refs['card-change-record'].search()
    },
    onCreateTimeChanged (datetime) {
      if (!datetime || datetime[0] == null) {
        this.queryParams.createTimeSearchStart = null
        this.queryParams.createTimeSearchEnd = null
        this.$refs['distributor-manager'].search()
        return
      }
      this.queryParams.createTimeSearchStart = datetime[0].getTime()
      this.queryParams.createTimeSearchEnd = datetime[1].getTime()
      this.$refs['distributor-manager'].search()
    },
    getCompanyColor (status) {
      let color = ''
      switch (status) {
        case 3:// 3-已认证
          color = '#00CC00'
          break
        case 2:// 2-待审核;
          color = '#FF0000'
          break
        default:// 1-未认证;
          color = '#909399'
      }
      return color
    },
    getRealNameAuthColor (status) {
      let color = ''
      switch (status) {
        case 3:// 3-已认证
          color = '#00CC00'
          break
        case 2:// 2-待审核;
          color = '#FF0000'
          break
        default:// 1-未认证;
          color = '#909399'
      }
      return color
    }
  }
}
</script>
